import { lazy } from 'react'

export const AddProductFunctionalitiesModalAsync = lazy(
    () => import('./AddProductFunctionalitiesModal')
        .then(component => ({ default: component.AddProductFunctionalitiesModal }))
)
